module.exports = __webpack_public_path__ + "img/mind-map.3ef0833e.png";